<template>
    <div class="container-wrapper">
        <div class="container-left">
            <p class="display-title" style="">{{ $t('message.txtManagement.lableSideTitle') }}</p>

            <a-spin :spinning="spinningTreeMenu" style="min-height:100px">
              <a-tree
                v-if="labelTreeData.length"
                :replaceFields="replaceFields"
                :tree-data="labelTreeData"
                :checkedKeys="defaultSelectedKeys"
                :defaultSelectedKeys="defaultSelectedKeys"
                :defaultExpandedKeys="defaultExpandedKeys"
                show-line
                @select="onSelectLabel">
              </a-tree>
            </a-spin>
        </div>
        <div class="container-right">
            <div class="title-container">
                <div class="display-title">{{ $t('message.txtManagement.lableTitle1') }} </div>
                <a-button  :size="$globalSize"  type="primary" @click="addLabelHandle">{{ $t('message.txtManagement.lableTitle2') }}</a-button>
            </div>
            <a-table
                :columns="labelColumns"
                row-key="id"
                :pagination="pagination"
                :data-source="labelLevelData"
                :loading = tableLoading
            >
                <template slot="operation" slot-scope="text, record">
                    <a-tooltip placement="top">
                        <template slot="title"><span>{{ $t('message.txtManagement.lableTitle3') }}</span></template>
                        <a-button  :size="$globalSize"  type="primary" class="edit-btn-icon" shape="circle" @click="editLabelHandle(record)" />
                    </a-tooltip>
                    <a-tooltip placement="top">
                    <template slot="title"><span>{{ $t('message.txtManagement.lableTitle4') }}</span></template>
                    <a-tooltip placement="top">
                        <a-popconfirm :title="$t('message.txtManagement.lableTitle5')" @confirm ="deleteLabelHandle(record)">
                        <a-button  :size="$globalSize"  class="delete-btn-icon" type="primary" shape="circle" ></a-button>
                        </a-popconfirm>
                    </a-tooltip>
                    </a-tooltip>
                </template>
            </a-table>
        </div>

        <a-modal
            :visible="copyLabelVisible"
            :title="titleName"
            :width="800"
            :okText="$t('message.txtManagement.lableEditTitle1')"
            :confirmLoading="saveBtnLoading"
            @cancel="copyLabelVisible = false"
            @ok="comfirmAddLabel"
            :maskClosable="false"
            :destroyOnClose="true"
        >
            <a-form-model
                ref="ruleForm"
                :rules="addListRules"
                :model="labelInfo"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 15 }"
            >
                <a-form-model-item :label="$t('message.txtManagement.lableEditTitle2')" prop="tag_id" >
                    <a-input-number :size="$globalSize" style="width:100%" :min="1" :max="9000000000000000" v-model="labelInfo.tag_id" :placeholder="$t('message.txtManagement.lableMsg1')"/>
                </a-form-model-item>
                <a-form-model-item :label="$t('message.txtManagement.lableEditTitle3')" prop="name" >
                    <a-input :size="$globalSize" v-model="labelInfo.name" :placeholder="$t('message.txtManagement.lableEditTitle4')"/>
                </a-form-model-item>
                <a-form-model-item :label="$t('message.txtManagement.lableEditTitle5')" prop="parent_id">
                    <!-- <a-select :size="$globalSize" allowClear @change="onChangeForchUpdate" v-model="labelInfo.parent_id" placeholder="请选择父级">
                        <a-select-option v-for="item in parentData" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select> -->
                    <a-tree-select :size="$globalSize"
                        @change="onChangeForchUpdate"
                        v-model="labelInfo.parent_id"
                        :getPopupContainer="(triggerNode) => { return triggerNode.parentNode;}"
                        treeNodeFilterProp="title"
                        show-search
                        allowClear
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :placeholder="$t('message.txtManagement.lableEditTitle6')"
                        :tree-data="treeData"
                        :replaceFields="{ children:'children', title:'title', key:'id', value: 'id' }"
                    ></a-tree-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('message.txtManagement.lableEditTitle7')" prop="status">
                    <a-radio-group :size="$globalSize" v-model="labelInfo.status">
                        <a-radio :value="1"> {{ $t('message.txtManagement.lableEditTitle8') }} </a-radio>
                        <a-radio :value="0"> {{ $t('message.txtManagement.lableEditTitle9') }} </a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
      </a-modal>
    </div>
</template>

<script>
import ContentLabel from "@/interface/pages/TxtManagement/contentLabel";

export default {
    name: "copyLabel",
    data(){
        return{
            // tag
            spinningTreeMenu: false,
            labelTreeData: [],
            replaceFields: {children:'children', title:'title', key:'id'},
            defaultSelectedKeys: [],
            defaultExpandedKeys: [],

            // table
            tableLoading: false,
            labelLevelData: [],
            pagination: {
                position: "bottom",
                defaultPageSize: 10, //默认当前页数据量
                showTotal: (total) => `${this.$t('message.commonUsage.total')} ${this.labelLevelData.length} ${this.$t('message.commonUsage.records')}`, //数据总量
                showSizeChanger: true, //显示当前页数据量改变
                pageSizeOptions: ["5", "8", "10", "15"], //页容量显示
                onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
                showQuickJumper: true //显示跳转
            },
            labelColumns: [
                { title: this.$t('message.txtManagement.lableEditTitle2'), dataIndex: "tag_id", width: 150 },
                { title: this.$t('message.txtManagement.lableEditTitle3'), dataIndex: "name" },
                { title: this.$t('message.txtManagement.lableEditTitle5'), dataIndex: "parent_name" },
                { title: this.$t('message.userManagement.tableAction'), dataIndex: "operation", width: 130, scopedSlots: { customRender: "operation" }},
            ],
            // 编辑和修改
            copyLabelVisible: false,
            titleName: '新建标签',
            labelInfo: { id: null, tag_id: '', name: '', parent_id: '',status:null },
            // 新增编辑弹窗
            addListRules: {
                tag_id: [ { required: true, message: this.$t('message.txtManagement.lableMsg1'), trigger: 'change' } ],
                name: [ { required: true, message: this.$t('message.txtManagement.lableMsg2'), trigger: 'blur' } ],
                // parent_id: [ { required: true, message: '请选择父级标签', trigger: 'change' } ],
                status: [{ required: true, message: this.$t('message.txtManagement.lableMsg3'), trigger: 'change' }],
            },
            // parentData: [],
            saveBtnLoading: false,
            treeData: []
        }
    },
    created() {
        this.getLabelTreeMenu()
    },
    methods:{
        editLabelHandle(record) {
            this.labelInfo = JSON.parse(JSON.stringify(record))
            if(record.parent_id === 0) {
                this.labelInfo.parent_id = void 0
            }
            // this.getParentTags()
            this.titleName = this.$t('message.txtManagement.lableEditTitle')
            this.copyLabelVisible = true
        },
        addLabelHandle() {
            this.labelInfo = { tag_id: '', name: '', parent_id: '',status:null },
            // this.getParentTags()
            this.titleName = this.$t('message.txtManagement.lableAddTitle')
            this.copyLabelVisible = true
        },
        deleteLabelHandle(row) {
            const params = {
                id: row.id
            }
            ContentLabel.deleteContentTag(this, {params}).then(function (response) {
                let res = response.data;
                if (res.code === '200') {
                    this.$message.success(res.message);
                    this.getLabelTreeMenu()
                } else {
                    this.$message.error(res.message);
                }
            }.bind(this)).catch(response => {
                this.$message.error(response);
            });
        },
        // 获取标签的接口
        getLabelTreeMenu() {
            this.spinningTreeMenu = true
            ContentLabel.getContentTagList(this,{params:{}}).then((response)=>{
                let res = response.data;
                if(res.code == 200) {
                    this.labelTreeData = res.data;
                    this.treeData = res.data
                    let defaultId = this.labelTreeData[0].id
                    this.defaultSelectedKeys = [defaultId]
                    this.defaultExpandedKeys = [defaultId]
                    this.spinningTreeMenu = false
                    this.getTagsByLevel(defaultId)
                }
            }).catch((error)=>{
                console.log("查询失败！" + error);
            }).finally(()=>{
                this.spinningTreeMenu = false
            })
        },
        // table 接口
        onSelectLabel(selectedKeys, info) {
            let seleKey = selectedKeys[0]
            this.getTagsByLevel(seleKey)            
        },
        getTagsByLevel(pid) {
            this.tableLoading = true
            this.labelLevelData = []
            ContentLabel.getContentTagByPid(this,{params:{pid}}).then((response)=>{
                let res = response.data;
                    if(res.code == 200){
                        this.labelLevelData = res.data;
                    }
                }).catch((error)=>{
                    console.log("查询失败！" + error);
                }).finally(()=>{
                    this.tableLoading = false
                })
        },
        // getParentTags() {
        //     this.parentData = []
        //     const pid = 0
        //     ContentLabel.getContentTagByPid(this,{params:{pid}}).then((response)=>{
        //         let res = response.data;
        //         if(res.code == 200) {
        //             this.parentData = res.data;
        //         }
        //     }).catch((error)=>{
        //         console.log("查询失败！" + error);
        //     })
        // },
        addContentLabel(params) {
            this.saveBtnLoading = true
            ContentLabel.addContentTag(this, {data: params}).then((response) => {
                let res = response.data
                if (res.code === '200') {
                    this.$message.success(res.message)
                    this.copyLabelVisible = false
                    this.getLabelTreeMenu()
                } else {
                    this.$message.error(res.message)
                }
            })
            .catch((error) => {
                this.$message.error(error);
            })
            .finally(()=>{
                this.saveBtnLoading = false
            })
        },
        updateContentLabel(params) {
            this.saveBtnLoading = true
            ContentLabel.updateContentTag(this, {data: params}).then((response) => {
                let res = response.data
                if (res.code === '200') {
                    this.$message.success(res.message)
                    this.copyLabelVisible = false
                    this.getLabelTreeMenu()
                } else {
                    this.$message.error(res.message)
                }
            })
            .catch((error) => {
                this.$message.error(error);
            })
            .finally(()=>{
                this.saveBtnLoading = false
            }) 
        },
        comfirmAddLabel() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if(this.titleName === '新增标签') {
                        this.addContentLabel(this.labelInfo)
                    } else {
                        this.updateContentLabel(this.labelInfo)
                    } 
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        onChangeForchUpdate() {
            this.$forceUpdate()
        }
    }
}
</script>
<style scoped lang="less">
.container-wrapper {
    .container-left {
        display: inline-block;
        width: 28%;
        vertical-align: top;
        overflow-x:auto;
        .display-title {
            font-weight:bold;
            color:#000
        }
    }
    .container-right {
        display: inline-block;
        width: 72%;
        vertical-align: top;
        .title-container {
            display: flex;
            justify-content: space-between;
        }
        .display-title {
            font-weight:bold;
            color:#000
        }
    }
}
</style>
